import Vue from "vue";
import Vuetify from "vuetify/lib";
import "@mdi/font/css/materialdesignicons.css";
import "../styles/variables.scss";
import CalendarIcon from "../assets/CalendarIcon.vue";
import ReportIcon from "../assets/ReportIcon.vue";
import DragHandleIcon from "../assets/DragHandleIcon.vue";
import DollarIcon from "../assets/DollarIcon.vue";
import AppStoreIcon from "../assets/AppStoreIcon.vue";
import AppStoreSecondaryIcon from "@/assets/app-store-secondary-icon";
import BillableIcon from "../assets/BillableIcon.vue";
import NonBillableIcon from "../assets/NonBillableIcon.vue";
import HandshakeIcon from "../assets/HandshakeIcon.vue";
import {
    Home,
    CalendarDays,
    BarChart,
    BarChart4,
    Euro,
    Contact,
    ScanFace,
    ClipboardList,
    HeartHandshake,
    HelpCircle,
    Cog,
    User,
    Users,
    UserCheck,
    ListChecks,
    UserPlus,
    SidebarOpen,
    SidebarClose,
    ShieldAlert,
    AlertCircle,
    Briefcase,
    AlignVerticalSpaceAround,
    CheckCircle,
    CheckSquare,
    SquarePen,
    Check,
    Square,
    ClipboardCopy,
    CreditCard,
    Edit,
    Globe,
    Flag,
    BookmarkPlus,
    Bell,
    MessageSquare,
    MessageSquareText,
    PlayCircle,
    Clock4,
    Calendar,
    Download,
    Upload,
    X,
    XCircle,
    Plus,
    Save,
    CheckCheck,
    SlidersHorizontal,
    MoreVertical,
    MoreHorizontal,
    ChevronLeft,
    ChevronRight,
    ChevronUp,
    ChevronDown,
    Columns,
    RotateCw,
    Replace,
    FormInput,
    Paperclip,
    Mail,
    Phone,
    Circle,
    Pencil,
    Copy,
    Trash,
    Trash2,
    GripVertical,
    PlusSquare,
    Info,
    ImagePlus,
    Camera,
    CalendarRange,
    CalendarClock,
    Search,
    FileSearch2,
    Files,
    Delete,
    Hourglass,
    Table,
    FileX,
    Send,
    CurlyBraces,
    Eye,
    EyeOff,
    FileText,
    Star,
    Link,
    Tag,
    UploadCloud,
    Text,
    GraduationCap,
    ExternalLink,
    AlertTriangle,
    FileInput,
    Monitor,
    MonitorOff,
    Palmtree,
    Clock,
    Footprints,
    Accessibility,
    Baby,
    Lock,
    Frown,
    TimerOff,
    Timer,
    Pen,
    LayoutGrid,
    Languages,
    Reply,
    BookText,
    Book,
    DollarSign,
    Building2,
    Cake,
    Megaphone,
    AlignLeft,
    PanelRightClose,
    PanelRightOpen,
    Folder,
    FolderOpen,
    Calculator,
    Navigation,
    NavigationOff,
    icons
} from 'lucide-vue';
import CommentFilled from "@/assets/icons/CommentFilled"
import ExternalOff from "@/assets/icons/ExternalOff.vue";
import StarFilled from "@/assets/icons/StarFilled.vue";

import { Ripple } from "vuetify/lib/directives";

Vue.use(Vuetify, {
    directives: {
        Ripple
    }
});

// We need to show all lucide icons for client portal menu links so we import and map them here
// However for example "SidebarOpen" icon.
// This icon does not exists in icons variable, but it does when importing it directly
// This should technically be a removed icon from lucide.
// Ideally we should delete all these icon imports as well now,
// However since it has a chance to break things I will leave it for now
const mappedIcons = {}
for (const icon of Object.keys(icons)) {
    mappedIcons[icon] = {
        component: icons[icon]
    }
}

export default new Vuetify({
    icons: {
        iconfont: "mdi",
        values: {
            ...mappedIcons,
            Home: { component: Home },
            CalendarClock: { component: CalendarClock },
            CalendarDays: { component: CalendarDays },
            Calendar: { component: Calendar },
            BarChart: { component: BarChart },
            BarChart4: { component: BarChart4 },
            Euro: { component: Euro },
            Contact: { component: Contact },
            ScanFace: { component: ScanFace },
            ClipboardList: { component: ClipboardList },
            HeartHandshake: { component: HeartHandshake },
            HelpCircle: { component: HelpCircle },
            Cog: { component: Cog },
            User: { component: User },
            Users: { component: Users },
            UserCheck: { component: UserCheck },
            ListChecks: { component: ListChecks },
            UserPlus: { component: UserPlus },
            SidebarOpen: { component: SidebarOpen },
            SidebarClose: { component: SidebarClose },
            ShieldAlert: { component: ShieldAlert },
            Briefcase: { component: Briefcase },
            AlignVerticalSpaceAround: { component: AlignVerticalSpaceAround },
            CheckCircle: { component: CheckCircle },
            Check: { component: Check },
            ClipboardCopy: { component: ClipboardCopy },
            CreditCard: { component: CreditCard },
            Edit: { component: Edit },
            Globe: { component: Globe },
            Flag: { component: Flag },
            BookmarkPlus: { component: BookmarkPlus },
            Bell: { component: Bell },
            MessageSquare: { component: MessageSquare },
            MessageSquareText: { component: MessageSquareText },
            PlayCircle: { component: PlayCircle },
            Clock4: { component: Clock4 },
            Download: { component: Download },
            Upload: { component: Upload },
            X: { component: X },
            XCircle: { component: XCircle },
            Plus: { component: Plus },
            Save: { component: Save },
            CheckCheck: { component: CheckCheck },
            SlidersHorizontal: { component: SlidersHorizontal },
            MoreVertical: { component: MoreVertical },
            MoreHorizontal: { component: MoreHorizontal },
            ChevronLeft: { component: ChevronLeft },
            ChevronRight: { component: ChevronRight },
            ChevronUp: { component: ChevronUp },
            ChevronDown: { component: ChevronDown },
            Columns: { component: Columns },
            RotateCw: { component: RotateCw },
            Replace: { component: Replace },
            FormInput: { component: FormInput },
            Paperclip: { component: Paperclip },
            Mail: { component: Mail },
            Phone: { component: Phone },
            Circle: { component: Circle },
            Pencil: { component: Pencil },
            Copy: { component: Copy },
            Eye: { component: Eye },
            EyeOff: { component: EyeOff },
            Trash: { component: Trash },
            Trash2: { component: Trash2 },
            GripVertical: { component: GripVertical },
            PlusSquare: { component: PlusSquare },
            Info: { component: Info },
            ImagePlus: { component: ImagePlus },
            Camera: { component: Camera },
            CalendarRange: { component: CalendarRange },
            Search: { component: Search },
            FileSearch2: { component: FileSearch2 },
            Files: { component: Files },
            Navigation: { component: Navigation },
            NavigationOff: { component: NavigationOff },
            Delete: { component: Delete },
            CheckSquare: { component: CheckSquare },
            Square: { component: Square },
            Hourglass: { component: Hourglass },
            Table: { component: Table },
            FileX: { component: FileX },
            Send: { component: Send },
            CurlyBraces: { component: CurlyBraces },
            FileText: { component: FileText },
            Star: { component: Star },
            Link: { component: Link },
            ExternalLink: { component: ExternalLink },
            Tag: { component: Tag },
            UploadCloud: { component: UploadCloud },
            Text: { component: Text },
            GraduationCap: { component: GraduationCap },
            AlertTriangle: { component: AlertTriangle },
            FileInput: { component: FileInput },
            AlertCircle: { component: AlertCircle },
            SquarePen: { component: SquarePen },
            PanelRightClose: { component: PanelRightClose },
            PanelRightOpen: { component: PanelRightOpen },

            ExternalOff: { component: ExternalOff },
            CommentFilled: { component: CommentFilled },
            StarFilled: { component: StarFilled },
            dropdown: { component: ChevronDown },
            Monitor: { component: Monitor },
            MonitorOff: { component: MonitorOff },
            Palmtree: { component: Palmtree },
            Clock: { component: Clock },
            Footprints: { component: Footprints },
            Accessibility: { component: Accessibility },
            Baby: { component: Baby },
            Lock: { component: Lock },
            Frown: { component: Frown },
            TimerOff: { component: TimerOff },
            Timer: { component: Timer },
            Pen: { component: Pen },
            LayoutGrid: { component: LayoutGrid },
            Languages: { component: Languages },
            Reply: { component: Reply },
            BookText: { component: BookText },
            Book: { component: Book },
            DollarSign: { component: DollarSign },
            Building2: { component: Building2 },
            Cake: { component: Cake },
            Megaphone: { component: Megaphone },
            AlignLeft: { component: AlignLeft },
            Folder: { component: Folder },
            FolderOpen: { component: FolderOpen },
            Calculator: { component: Calculator },

            calendar_range: {
                component: CalendarIcon
            },
            app_store: {
                component: AppStoreIcon
            },
            poll_box: {
                component: ReportIcon
            },
            dollar: {
                component: DollarIcon
            },
            drag_handle_vertical: {
                component: DragHandleIcon
            },
            billable: {
                component: BillableIcon
            },
            non_billable: {
                component: NonBillableIcon
            },
            handshake: {
                component: HandshakeIcon
            },
            app_store_secondary: {
                component: AppStoreSecondaryIcon
            }
        }
    },
    theme: {
        options: {
            customProperties: true
        },
        themes: {
            light: {
                background: "#ebebeb",
                main: {
                    base: "#251D35",
                    lighten1: "#424242"
                },
                primary: {
                    base: "#007AFF",
                    lighten1: "#add4ff",
                    lighten2: "#d6eaff"
                },
                secondary: {
                    base: "#FF9500",
                    lighten1: "#FFD599",
                    lighten2: "#FFF3C2",
                    darken1: "#FBEBCF"
                },
                tretiary: {
                    base: "#38B000",
                    darken1: "#27AE60",
                    lighten1: "#BFE6AD",
                    lighten2: "#E2F1D8",
                    lighten3: "#DFF2D6",
                    lighten4: "#ECF7E6"
                },
                error: {
                    base: "#F4511E",
                    lighten1: "#FBC7B7",
                    lighten2: "#FDE3DB"
                },
                purple: {
                    base: "#988AFF",
                    lighten1: "#D8D0FE",
                    darken1: "#AD59DC"
                },
                yellow: {
                    base: "#ffcc00",
                    lighten1: "#ffe785"
                },
                orange: {
                  base: "#F19A37",
                  lighten1: "#F8D7A1",
                  lighten2: "#FBEBCF"
                },
                'royal-blue': {
                    base: "#5B5DE4",
                    lighten1: "#CACBF6",
                    lighten2: "#E5E5FB"
                },
                pink: {
                    base: "#FD4B78",
                    lighten1: "#FEC5D4"
                },
                inverted: "#fff",
                gray: {
                    base: "#9E9E9E",
                    lighten1: "#BDBDBD",
                    lighten2: "#E0E0E0",
                    lighten3: "#EEEEEE",
                    lighten4: "#F5F5F5",
                    lighten5: "#FAFAFA",
                    darken1: "#757575",
                    darken2: "#616161",
                    darken3: "#424242",
                    darken4: "#212121"
                },
                white: "#fff",

                g1: "#f5f5f5",
                g2: "#ebebeb",
                g3: "#e0e0e0",
                g4: "#999999",
                g5: "#5c5c5c",

                n1: "#f6f7f8",
                n15: "#eeeff2",
                n2: "#dcdfe4",
                n3: "#8590A1",
                n4: "#627086",
                n5: "#253957",

                /* design system colors */

                shade_color: "#F0F0F0",
                neutral_n10: "#FAFBFC",
                neutral_n20: "#F4F5F7",
                neutral_n40: "#DFE1E6",
                neutral_n50: "#C1C7D0",
                neutral_n60: "#B3BBC5",
                neutral_n70: "#A5AEBA",
                neutral_n80: "#97A1AF",
                neutral_n90: "#8994A4",
                neutral_n100: "#7A879A",
                neutral_n200: "#6B788C",
                neutral_n300: "#6B788C",
                neutral_n400: "#5E6D84",
                neutral_n500: "#42536D",
                neutral_n600: "#344662",
                neutral_n700: "#253957",
                neutral_n800: "#172C4C",
                neutral_n900: "#082041",

                /* design system colors end */

                "color-1": "#D32F2F",
                "color-2": "#EF5350",
                "color-3": "#C2185B",
                "color-4": "#EC407A",
                "color-5": "#7B1FA2",
                "color-6": "#AB47BC",

                "color-7": "#512DA8",
                "color-8": "#7E57C2",
                "color-9": "#303F9F",
                "color-10": "#5C6BC0",
                "color-11": "#1976D2",
                "color-12": "#42A5F5",

                "color-13": "#0288D1",
                "color-14": "#29B6F6",
                "color-15": "#0097A7",
                "color-16": "#26C6DA",
                "color-17": "#00796B",
                "color-18": "#26A69A",

                "color-19": "#388E3C",
                "color-20": "#81C784",
                "color-21": "#689F38",
                "color-22": "#AED581",
                "color-23": "#9E9D24",
                "color-24": "#D4E157",

                "color-25": "#FBC02D",
                "color-26": "#FFEB3B",
                "color-27": "#FFA000",
                "color-28": "#FFCA28",
                "color-29": "#F57C00",
                "color-30": "#FFAB40",

                "color-31": "#F4511E",
                "color-32": "#FF7043",
                "color-33": "#6D4C41",
                "color-34": "#8D6E63",
                "color-35": "#616161",
                "color-36": "#BDBDBD",

                "color-37": "#546E7A",
                "color-38": "#90A4AE",
                "color-39": "#03549D",
                "color-40": "#0274BF",
                "color-41": "#81DC47",
                "color-42": "#52D595",

                "color-43": "#49AF07",
                "color-44": "#7ED321",
                "color-45": "#FF1744",
                "color-46": "#FF5252",
                "color-47": "#C51162",
                "color-48": "#FF4081"
            },
            dark: {
                text_primary: "#fff",
                text_secondary: "#fff",
                filter_button: "#000",
                drawer_menu_item_active: "#292929",
                inverted: "#000",
                "color-1": "#D32F2F",
                "color-2": "#EF5350",
                "color-3": "#C2185B",
                "color-4": "#EC407A",
                "color-5": "#7B1FA2",
                "color-6": "#AB47BC",

                "color-7": "#512DA8",
                "color-8": "#7E57C2",
                "color-9": "#303F9F",
                "color-10": "#5C6BC0",
                "color-11": "#1976D2",
                "color-12": "#42A5F5",

                "color-13": "#0288D1",
                "color-14": "#29B6F6",
                "color-15": "#0097A7",
                "color-16": "#26C6DA",
                "color-17": "#00796B",
                "color-18": "#26A69A",

                "color-19": "#388E3C",
                "color-20": "#81C784",
                "color-21": "#689F38",
                "color-22": "#AED581",
                "color-23": "#9E9D24",
                "color-24": "#D4E157",

                "color-25": "#FBC02D",
                "color-26": "#FFEB3B",
                "color-27": "#FFA000",
                "color-28": "#FFCA28",
                "color-29": "#F57C00",
                "color-30": "#FFAB40",

                "color-31": "#F4511E",
                "color-32": "#FF7043",
                "color-33": "#6D4C41",
                "color-34": "#8D6E63",
                "color-35": "#616161",
                "color-36": "#BDBDBD",

                "color-37": "#546E7A",
                "color-38": "#90A4AE",
                "color-39": "#03549D",
                "color-40": "#0274BF",
                "color-41": "#81DC47",
                "color-42": "#52D595",

                "color-43": "#49AF07",
                "color-44": "#7ED321",
                "color-45": "#FF1744",
                "color-46": "#FF5252",
                "color-47": "#C51162",
                "color-48": "#FF4081"
            }
        }
    }
});
